<template>
  <div class="icp">{{`© ${year} ${author} ` }}<a href="https://beian.miit.gov.cn/" target="_blank">{{ record }}</a></div>
</template>

<script>
export default{
  props: {
    year: {
      default: new Date().getFullYear()
    },
    auth: {
      default: '安徽艾可蓝环保股份有限公司'
    },
    record: {
      default: '皖ICP备09015450号-3'
    }
  },
  data() {
    return {
      year: new Date().getFullYear(),
      author: '安徽艾可蓝环保股份有限公司',
      record: '皖ICP备09015450号-3'
    }
  }
}
</script>

<style>
.icp {
position: absolute;
bottom: 0;
right: 0;
margin: 0 0;
width: 100%;
height: 36px;
white-space: pre;
text-align: center;
color: white;
z-index: 1000;
font: 12px Arial,sans-serif
}
.icp > a {
  color: white;
  text-decoration: none;
}
.icp > a:hover {
  color: aqua;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/copyright-icp.vue